import type { AccountSetting } from '@/services/auth/account-settings';
import { useAccountSetting } from '@/services/auth/account-settings';

/**
 * Renders children only when the given account setting
 * (`accounts.public_settings`) is on. Falls back to a custom fallback or renders
 * nothing by default. Subscribes to the account store, so guarded content reacts
 * to setting changes within a session. The account-setting analogue of
 * {@link FeatureFlagGuard}.
 */

type AccountSettingGuardProps = {
  setting: AccountSetting;
  fallback?: React.ComponentType;
  children: React.ReactNode;
};

export function AccountSettingGuard({ setting, fallback: Fallback, children }: AccountSettingGuardProps) {
  const enabled = useAccountSetting(setting);

  if (!enabled) {
    return Fallback != null ? <Fallback /> : null;
  }

  return <>{children}</>;
}
